import axios from "../../axios";

export default {
    getQuickSightDashboard() {
        return axios.get('/poi-locations/dashboard-credentials')
    },
    getProviders() {
        return axios.post('poi-locations/providers')
    },
    getSegments(data) {
        return axios.post('poi-locations/segments', data)
    },
    getCategories(data) {
        return axios.post('poi-locations/categories', data)
    },
    getPois(data) {
        return axios.post('poi-locations/pois', data)
    },
    getReviews() {
        return axios.post('poi-locations/reviews')
    },
    getCohorts() {
        return axios.post('poi-locations/cohorts')
    },
    getAddresses(data) {
        return axios.post('poi-locations/addresses', data)
    },
    getLocationNames(data) {
        return axios.post('poi-locations/location-names', data)
    },
    getCities(data) {
        return axios.post('poi-locations/cities', data)
    },
    getDmas(data) {
        return axios.post('poi-locations/dmas', data)
    },
    getCountries(data) {
        return axios.post('poi-locations/countries', data)
    },
    getStates(data) {
        return axios.post('poi-locations/states', data)
    },
    getCompanies(data) {
        return axios.post('poi-locations/companies', data)
    },
    getKeys(data) {
        return axios.post('poi-locations/keys', data)
    },
    getDataByChangedField(data) {
        return axios.post('poi-locations/data-by-changed-field', data)
    },
    getInitialData(data) {
        return axios.post('poi-locations/initial-data', data)
    }
}